import { Permission } from '../../../enums';
import { Permissions } from '../../../models/Permissions';

// some of the permissions logic for the channel editor is tied to multiple individual permissions...this gives us a comvenient place to put that logic...
export class LiveProgramFormPermissions {
  permissions: Permissions = null;
  
  load(permissions: Permissions) {
    this.permissions = permissions;
  }

  // there's no explicit permission that represents this, but i think its reasonable to extrapolate this from the permissions that control editing on each of the
  //   3 steps...
  isAllEditingDisabled(): boolean {
    return (
      !this.permissions.has(Permission.EditLiveProgramInfo) &&
      !this.permissions.has(Permission.EditProgramLiveTransitions) &&
      !this.permissions.has(Permission.EditGeoFencing)
    );
  }

  isEditingInfoStepDisabled(): boolean {
    return !this.permissions.has(Permission.EditLiveProgramInfo);
  }

  isInterruptsToggleDisabled(): boolean {
    if (this.isEditingInfoStepDisabled()) return true;
    return !this.permissions.has(Permission.EditProgramLiveTransitions);
  }

  areScteControlsDisabled(): boolean {
    if (this.isEditingInfoStepDisabled()) return true;
    return !this.permissions.has(Permission.SCTETriggers);
  }

  isGeoFencingToggleDisabled(): boolean {
    if (this.isEditingInfoStepDisabled()) return true;
    return !this.permissions.has(Permission.GeoFencing);
  }

  isTimeZoneDisabled(): boolean {
    if (this.isEditingInfoStepDisabled()) return true;
    return !this.permissions.has(Permission.TimeZone);
  }

  isEditingLiveTransitionStepDisabled(): boolean {
    return !this.permissions.has(Permission.EditProgramLiveTransitions);
  }

  isEditingGeoFencingStepDisabled(): boolean {
    return !this.permissions.has(Permission.EditGeoFencing);
  }

  has(id: Permission): boolean {
    return this.permissions.has(id);
  }
}
